<template>
  <div class="detail">
    <div class="banner"><img src="./images/banner.png" alt="" width="100%"></div>
    <div class="detail-main">
      <p class="title">{{newsInfo.title}}</p>
      <p class="tips">
        <span class="mr30">发布人：<em>{{newsInfo.Publisher}}</em></span>
        <span>发布时间：<em>{{newsInfo.time}}</em></span>
      </p>
      <div class="content" >
        <div class="text" v-for="(item,index) in newsInfo.content" :key="index">
          <img class="marks-left" v-if="item.marksLeft" :src="item.marksLeft">
          <p class="newsDetail" v-if="item.text" v-html="item.text"></p>
          <p v-if="item.imgurl" class="pic"><img :src="item.imgurl" alt=""></p>
          <p class="imgDetail" v-if="item.imgDetail" v-html="item.imgDetail"></p>
          <img class="marks-right" v-if="item.marksRight" :src="item.marksRight">
        </div>
      </div>
      <p class="pages" v-if="newsInfo">
        <a v-if="ifPrev" class="prev" :href="`/newsDetail/${newsList[currentIndex-1].id}`">上一篇</a>
        <a v-if="ifNext" class="next" :href="`/newsDetail/${newsList[currentIndex+1].id}`">下一篇</a>
      </p>
    </div>
    <go-top></go-top>
  </div>
</template>

<script>
import goTop from "../../common/go-top.vue";
  const newsList = require('../../../static/data/news-list');
export default {
  name: 'NewsDetail',
  components: {
    goTop
  },
  data(){
    return{
        newsId: this.$route.params.id || null,
        newsList: JSON.parse(JSON.stringify(newsList)),
        newsInfo: null,
        ifPrev: false,
        ifNext: false,
        currentIndex: null
      }
  },
  created(){
    this.checkPageTurning();
    this.setNewsData(this.newsId);
  },
  watch: {
    '$route': function (route) {
      const {params} = route;
      this.newsId = params.id-0;
      this.checkPageTurning();
      this.setNewsData(this.newsId);
    }
  },
  methods: {
    setNewsData(id){
      const currentNews = this.newsList[id];
      const {content} = currentNews;
      content.forEach(item => {
        item.imgurl = item.imgurl ? require(`./images/${item.imgurl}`) : '';
        if(item.marksRight){
          item.marksRight = item.marksRight ? require(`./images/${item.marksRight}`) : '';
        }
        if(item.marksLeft){
          item.marksLeft = item.marksLeft ? require(`./images/${item.marksLeft}`) : '';
        }
      });
      this.newsInfo = currentNews;
    },
    checkPageTurning(){
      const index = this.currentIndex = this.newsList.findIndex(item => item.id === this.newsId-0);
      this.ifPrev = !!this.newsList[index-1];
      this.ifNext = !!this.newsList[index+1];
    }
  }
}
</script>

<style scoped>
.detail {
  min-width: 1200px;
}
.banner{
  width: 100%;
}
.detail .detail-main{
  max-width: 1200px;
  margin: 46px auto;
  padding: 42px 62px;
  background: #ffffff;
  border: 1px solid #ced7e2;
  box-sizing: border-box;
}
.detail .title{
  font-size: 22px;
  font-weight: 600;
  color: #333;
  line-height: 40px;
}
.detail .tips{
  font-size: 14px;
  line-height: 40px;
}
.detail .tips span{
  display: inline-block;
}
.detail .tips .mr30{
  margin-right: 30px;
  margin-bottom: 20px;
}
.detail .tips em{
  font-style: normal;
  color: #003B83;
  font-weight: 600;
}
.detail .text{
  position: relative;
  color: #666;
  line-height: 24px;
  text-align: justify;
  margin-bottom: 24px;
  text-indent: 2em;
}
.detail .marks-left{
  position: absolute;
  top: -25px;
  left: -35px;
}
.detail .marks-right{
  position: absolute;
  bottom: -20px;
  right: -35px;
}
.detail .pic{
  text-align: center;
  margin: 20px 0 5px 0;
  text-indent: 0;
  overflow: hidden;
}
.detail .imgDetail{
 text-align: center;
 font-size: 14px;
 color: #7D7D7D;
}
.detail .pages {
  margin: 24px 0;
  text-align: right;
}
.detail .pages span{
  display: inline-block;
  cursor: pointer;
  margin: 0 15px;
  font-size: 14px;
}
.detail .pages span:hover{
  color: #003B83;
}
.detail .newsDetail{
  line-height: 34px;
}
/* .detail .newsDetail a{
  color: #666 !important;
} */
</style>




// WEBPACK FOOTER //
// src/components/newsDetail/NewsDetail.vue